/**
 * Quitter l'application pour de bon.
 *
 * **Pourquoi un module pour une ligne.** Un composant qui appelle
 * `window.location.assign` directement est intestable : jsdom rend `assign`
 * non redéfinissable, et un test qui ne peut pas observer la navigation ne
 * peut pas prouver qu'elle a lieu. Or c'est exactement ce qu'il faut prouver
 * ici — une déconnexion qui ne ramène pas à l'écran de connexion laisse le
 * candidat devant l'écran d'un compte qui n'existe plus.
 *
 * Ce n'est PAS un routeur : l'application n'en a pas (voir `App.tsx`). C'est
 * une sortie, et elle sert dans les rares cas où l'on veut qu'aucun fragment
 * d'état en mémoire ne survive — la déconnexion, et rien d'autre pour l'instant.
 */
export function rechargerVers(chemin: string): void {
  window.location.assign(chemin)
}
